function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 26s-9.538 8.834-11.188 10.248c-2.147 1.84 1.752 5.883 4.011 3.967 3.482-2.953 9.75-8.93 15.983-14.64 4.46-4.087-3.944-11.67-8.342-7.642L5.489 39.893c-4.795 4.393 7.718 15.855 12.513 11.463l31.967-29.282C56.363 16.217 39.838.788 33.445 6.644c-11.188 10.25-27.172 24.89-27.172 24.89",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgPaperclip = function SvgPaperclip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Paperclip.ca3950d0.svg";
export { ForwardRef as ReactComponent };